import { render, staticRenderFns } from "./consultationDetails.vue?vue&type=template&id=2033b0a2&scoped=true"
import script from "./consultationDetails.vue?vue&type=script&lang=js"
export * from "./consultationDetails.vue?vue&type=script&lang=js"
import style0 from "./consultationDetails.vue?vue&type=style&index=0&id=2033b0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2033b0a2",
  null
  
)

export default component.exports